import { BankFieldConfig, PaymentMethodType } from './PaymentMethods.types'

export const BANK_FIELDS: BankFieldConfig[] = [
	{ key: 'bankName', label: 'Bank', column: 'left' },
	{ key: 'type', label: 'Type', column: 'left' },
	{ key: 'currency', label: 'Currency', column: 'left' },
	{ key: 'fullAccountNumber', label: 'IBAN/CBU', column: 'left' },
	{ key: 'swift', label: 'Swift', column: 'left' },
	{ key: 'payTo', label: 'Pay to', column: 'left' },
	{ key: 'address', label: 'Address', column: 'left' },
	{ key: 'taxId', label: 'Company Tax ID', column: 'right' },
	{ key: 'accountName', label: 'Account Name', column: 'right' },
	{ key: 'accountNumber', label: 'Account number', column: 'right' },
	{ key: 'alias', label: 'Alias', column: 'right' },
	{ key: 'routing', label: 'Routing', column: 'right' },
	{ key: 'clabe', label: 'CLABE', column: 'right' },
	{
		key: 'finalCreditAccount',
		label: 'Final credit account',
		column: 'right',
	},
]

export const AUTOMATIC_PAYMENT_ALEGRA_ISOS = [
	'Alegra USA',
	'Alegra MEX',
	'Alegra ESP',
]

export const PAYMENT_METHOD_TYPES = {
	BANK: 'bank' as PaymentMethodType,
	CARD: 'card' as PaymentMethodType,
} as const
